// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__3X-83","footer":"ModalInfo_footer__2GTB4"};